import { pageDefinitionConfiguration } from 'site-modules/inventory/pages/usurp/usurp-definition';
import { pageDefinition } from 'site-modules/shared/pages/page';

export default pageDefinition({
  ...pageDefinitionConfiguration,
  chunkName: 'srp',
});
